import { toLocalISOString, withReportsFromDay } from '@/common/time'
import { Roles } from '@/services/repository/users'

export interface WizardData {
  from: Date
  to: Date
  selectMachines: boolean
  selectedMachineIds: string[] | null
}

export interface RankingMachineOption {
  id: string
  manufacturer: string
  category: string
  model: string
  internalNumber: string
  serialNumber: string
  groupIds: string[]
}

export interface RankingSelectionOptions {
  machines: RankingMachineOption[]
  groups: { id: string; name: string; namespaceName: string }[]
}

export const rankingMachineLabel = (machine: RankingMachineOption): string =>
  [machine.manufacturer.trim(), machine.model.trim(), machine.internalNumber.trim() || machine.id].filter(Boolean).join(' > ')

export const canSelectRankingMachines = (role?: string): boolean =>
  [Roles.HyperAdmin, Roles.SuperAdmin, Roles.CompanyAdmin, Roles.CompanyManager, Roles.Accountant].some(value => value === role)

export const machineRankingQuery = (data: WizardData, lang?: string): string => {
  const params = new URLSearchParams({ from: toLocalISOString(data.from), to: toLocalISOString(data.to) })
  if (lang) params.set('lang', lang)
  if (data.selectMachines) params.set('machines', [...new Set(data.selectedMachineIds || [])].join(','))
  return params.toString()
}

export const cleanWizardData = (): WizardData => {
  const yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  yesterday.setHours(0, 0, 0, 0)

  const endOfYesterday = new Date(yesterday);
  endOfYesterday.setHours(23, 59, 0, 0);

  const empty: WizardData = {
    from: yesterday,
    to: endOfYesterday,
    selectMachines: false,
    selectedMachineIds: null,
  };
  
  return withReportsFromDay(empty)
}
